module.exports = __webpack_public_path__ + "img/thomas-kusiek.925b43fa.jpg";